import { gql } from "@apollo/client";
import { composeResolvers } from "@graphql-tools/resolvers-composition";
import { inquiry } from "@/lib/mailTemplate";
import sendEmail from "@/lib/sendEmail";
export const typeDef = gql`
  type Result {
    result: Boolean
  }
  type Mutation {
    sendInquiryMail(
      name: String!
      mailAddress: String!
      membersId: String
      pastSpooxId: String
      subject: String!
      body: String!
      comment: String!
    ): Result
  }
`;
export const resolvers = composeResolvers({
  Mutation: {
    sendInquiryMail: async (_parent, _ref, _ref2) => {
      let {
        name,
        mailAddress,
        membersId,
        pastSpooxId,
        subject,
        body,
        comment
      } = _ref;
      let {} = _ref2;
      await sendEmail(inquiry({
        name,
        address: mailAddress,
        membersId,
        pastSpooxId,
        subject,
        body,
        comment
      }));
      return {
        result: true
      };
    }
  },
  User: {
    __resolveType(user) {
      switch (user.type) {
        case "account":
          return "AccountUser";
        case "profile":
          return "ProfileUser";
      }
      return "User";
    }
  }
}, {});